import { Modes } from '../common.js';

const ENV = process.env.VUE_APP_PLY_ENV;
const prefix = ENV === Modes.Production ? '' : `${ENV}`;

const StorageHelper = {
	wrapKey: (key) => `${prefix}_${key}`,
};

export default StorageHelper;
